import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";

export const getOrgQuotes = async (organization_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      const headers = { Authorization: "Bearer " + token.data };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/quotes/`;
        const response = await axios.get(endpoint, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Failed to fetch quotes:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("Unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

export const getOrgQuote = async (organization_id: any, quote_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      const headers = { Authorization: "Bearer " + token.data };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/quotes/${quote_id}/`;
        const response = await axios.get(endpoint, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Failed to fetch quote:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("Unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

export const deleteOrgQuote = async (organization_id: any, quote_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      const headers = { Authorization: "Bearer " + token.data };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/quotes/${quote_id}/`;
        const response = await axios.delete(endpoint, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Failed to fetch quote:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("Unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

export const updateOrgQuote = async (
  organization_id: string | number,
  quote_id: string | number,
  updates: {
    customer?: {
      first_name?: string;
      second_name?: string;
      title?: string;
    };
    notes?: string;
    status?: string;
    total_amount?: number;
  }
) => {
  try {
    const token = await getAuthToken();
    if (!token) {
      return { success: false, data: "error: Token does not exist" };
    }

    const headers = { Authorization: `Bearer ${token.data}` };
    const endpoint = `${baseUrl}/core/organizations/${organization_id}/quotes/${quote_id}/`;

    const response = await axios.patch(endpoint, updates, { headers });

    if (response.status >= 200 && response.status < 300) {
      return { success: true, data: response.data };
    } else {
      console.error("Updating quote failed:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error("Unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};


export const getOrgQuoteItems = async (organization_id: any, quote_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      const headers = { Authorization: "Bearer " + token.data };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/quotes/${quote_id}/items/`;
        const response = await axios.get(endpoint, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Failed to fetch quote items:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("Unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

export const getOrgQuoteItem = async (organization_id: any, quote_id: any, item_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      const headers = { Authorization: "Bearer " + token.data };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/quotes/${quote_id}/items/${item_id}/`;
        const response = await axios.get(endpoint, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Failed to fetch quote item:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("Unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

export const updateOrgQuoteItem = async (organization_id: any, quote_id: any, item_id: any, payload: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      const headers = { Authorization: "Bearer " + token.data };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/quotes/${quote_id}/items/${item_id}/`;
        const response = await axios.put(endpoint, payload, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Quote item update failed:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("Unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

export const deleteOrgQuoteItem = async (organization_id: any, quote_id: any, item_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      const headers = { Authorization: "Bearer " + token.data };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/quotes/${quote_id}/items/${item_id}/`;
        const response = await axios.delete(endpoint, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Quote item deletion failed:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("Unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};